<template>
    <div>
        <loading-custom :loading="loading" />

        <!-- Modal Trigger Button -->

        <div class="row">
            <div class="col-12">
                <div class="page_action">
                    <div class="tw-w-full text-right">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            data-toggle="modal"
                            data-target="#addMenu"
                        >
                            <i class="fa fa-plus"></i>
                            เพิ่มเมนู
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->

        <div
            class="modal"
            id="addMenu"
            tabindex="-1"
            role="dialog"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="tw-font-bold">เพิ่มเมนู</h5>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            id="closeMenuModal"
                            @click="onClose()"
                        >
                            &times;
                        </button>
                    </div>

                    <form @submit.prevent="handleSubmit()">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="title">
                                    ชื่อเมนู
                                    <span class="tw-text-gray-500 tw-text-xs">
                                        (
                                        <span
                                            :class="{
                                                'tw-text-red-500':
                                                    form.title.length > 255
                                            }"
                                        >
                                            {{ form.title.length }}
                                        </span>
                                        / 255 )
                                    </span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ชื่อเมนู"
                                    v-model="form.title"
                                />
                            </div>

                            <div class="tw-grid tw-grid-cols-1 tw-gap-2">
                                <label for="link"> Link : </label>

                                <div class="tw-flex tw-align-middle tw-py-1">
                                    <input
                                        type="radio"
                                        value="home"
                                        class="tw-mr-2"
                                        v-model="form.link_type"
                                    />

                                    <label for="home" class="tw-m-0">
                                        หน้าหลัก
                                    </label>
                                </div>

                                <div class="tw-grid tw-grid-cols-4 tw-gap-2">
                                    <div
                                        class="tw-col-span-1 tw-flex tw-align-middle"
                                    >
                                        <input
                                            type="radio"
                                            value="category"
                                            class="tw-mr-2"
                                            v-model="form.link_type"
                                        />

                                        <label
                                            for="category"
                                            class="tw-self-center tw-m-0"
                                        >
                                            หมวดหมู่
                                        </label>
                                    </div>

                                    <div class="tw-col-span-3">
                                        <select
                                            class="form-control tw-w-full tw-h-2"
                                            v-if="form.link_type == 'category'"
                                            v-model="form.link"
                                            :disabled="
                                                form.link_type != 'category'
                                            "
                                        >
                                            <option value="" disabled
                                                >โปรดเลือกหมวดหมู่</option
                                            >

                                            <option
                                                v-for="(category,
                                                index) in categories"
                                                :key="index"
                                                :value="category.id"
                                            >
                                                <i class="fa fa-folder"></i>
                                                {{ category.title }}
                                            </option>
                                        </select>

                                        <select
                                            class="form-control tw-w-full tw-h-2"
                                            disabled
                                            v-else
                                            v-model="form.link"
                                        ></select>
                                    </div>
                                </div>

                                <div class="tw-grid tw-grid-cols-4 tw-gap-2">
                                    <div class="tw-flex tw-align-middle">
                                        <input
                                            type="radio"
                                            value="external"
                                            class="tw-mr-2"
                                            v-model="form.link_type"
                                        />

                                        <label
                                            for="external"
                                            class="tw-self-center tw-m-0"
                                        >
                                            External Link
                                        </label>
                                    </div>

                                    <div class="tw-col-span-3">
                                        <input
                                            class="tw-w-full tw-py-1 tw-px-2"
                                            type="text"
                                            v-if="form.link_type == 'external'"
                                            v-model="form.link"
                                            :placeholder="
                                                form.link_type == 'external'
                                                    ? 'www.google.com'
                                                    : ''
                                            "
                                            :disabled="
                                                form.link_type != 'external'
                                            "
                                        />

                                        <input
                                            class="tw-w-full tw-py-1 tw-px-2"
                                            type="text"
                                            v-else
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer mt-2">
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="onClose()"
                            >
                                ยกเลิก
                            </button>

                            <button
                                type="submit"
                                class="btn btn-success"
                                aria-label="Submit"
                            >
                                บันทึก
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["shop", "salepageId"],
    data() {
        return {
            loading: false,
            categories: [],
            form: { title: "", link_type: "", link: "" }
        };
    },
    methods: {
        handleSubmit() {
            this.store();
        },
        async getCategories() {
            await axios
                .get(
                    `/ajax/s/${this.shop}/salepage/${this.salepageId}/categories`
                )
                .then(res => {
                    this.categories = res.data.categories;
                });
        },
        async store() {
            this.loading = true;
            await axios
                .post(
                    `/backend/s/${this.shop}/salepages/${this.salepageId}/menu`,
                    this.form
                )
                .then(res => {
                    if (res.data.status == "success") {
                        this.$emit("onStore", "success");
                    }
                })
                .catch(err => {
                    this.$swal({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "กรุณาใส่ข้อมูลให้ครบถ้วน",
                        showConfirmButton: true
                    });
                });
            this.loading = false;
            document.getElementById("closeMenuModal").click();
        },
        onClose() {
            this.form = {
                title: "",
                link_type: "",
                link: ""
            };
        }
    },
    mounted() {
        this.getCategories();
    },
    watch: {
        "form.link_type": function(value) {
            this.form.link = "";
        }
    }
};
</script>

<style lang="scss" scoped></style>
